export default "__VITE_ASSET__rgnXt6EV__"